import Vue from 'vue'
import Vuex from 'vuex'
import wpStore from './wp-store'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    wp: wpStore
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js